import React from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';




let ComingSoon = ({ title }) => {

 return (
  <>
   <DashboardLayout>
    <div className="container-fluid mt-4">
     <div className="row">
      <div className="col-12">
       <Breadcrumb>
        <Breadcrumb.Item href="#">
         Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{title}</Breadcrumb.Item>
       </Breadcrumb>
      </div>
     </div>
     <div className="row">
      <div className="col-12">
       <div className="bg-white p-3 overflow-hidden">
        <div className="d-flex justify-content-between border-bottom pb-2">
         <div>
          <h4>{title}</h4>
         </div>
        </div>
        <div className="container-fluid p-5 text-center my-5">
         <div className="row">
          <div className="col-12">
           <h1 className="display-6">We're Working on Something New!</h1>
           <p className="text-sm">Our team is currently developing exciting new features. Once they're ready, we'll notify you via email. Stay tuned for updates!</p>
          </div>
         </div>
        </div>
       </div>
       <br />
      </div>
     </div>
    </div>
   </DashboardLayout>
  </>
 )
}

export default ComingSoon